import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { retainPropertyFilter, todaySearch } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { loadToday } from "../today/loader.ts";
import { TodayPending } from "../today/pending.tsx";
import { TodayPage } from "../today/today-page.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || viewer.role === "vendor" ? <NoAccessPage /> : <TodayPage viewer={viewer} />;
};

// WHY: the greeting is the page title, so the top bar shows none (one title per screen).
export const Route = createFileRoute("/_app/today")({
  staticData: { hasPropertyContext: true },
  validateSearch: todaySearch,
  search: retainPropertyFilter(),
  loader: async ({ context }) => loadToday(context.data),
  pendingComponent: TodayPending,
  component: Page,
});
